import { render, staticRenderFns } from "./AdminStatsElement.vue?vue&type=template&id=4453e8e2&scoped=true"
import script from "./AdminStatsElement.vue?vue&type=script&lang=js"
export * from "./AdminStatsElement.vue?vue&type=script&lang=js"
import style0 from "./AdminStatsElement.vue?vue&type=style&index=0&id=4453e8e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4453e8e2",
  null
  
)

export default component.exports